import { render, staticRenderFns } from "./CaseSubheader.vue?vue&type=template&id=7c9f609f&scoped=true&"
import script from "./CaseSubheader.vue?vue&type=script&lang=ts&"
export * from "./CaseSubheader.vue?vue&type=script&lang=ts&"
import style0 from "./CaseSubheader.vue?vue&type=style&index=0&id=7c9f609f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9f609f",
  null
  
)

export default component.exports